export default "__VITE_ASSET__Crtw5eUh__"